import { ButtonList, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { useContext } from 'react';

type Props = {
  onEdit: () => void;
  onRename: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
};

export function FormRowDropdownContent({
  onEdit,
  onRename,
  onDuplicate,
  onDelete,
}: Props): JSX.Element {
  const { closeDropdown } = useContext(DropdownButtonContext);

  const handle = (cb: () => void) => () => {
    closeDropdown();
    cb();
  };

  return (
    <ButtonList>
      <ButtonList.Item onClick={handle(onEdit)}>Edit form</ButtonList.Item>
      <ButtonList.Item onClick={handle(onRename)}>Rename</ButtonList.Item>
      <ButtonList.Item onClick={handle(onDuplicate)}>Duplicate</ButtonList.Item>
      <ButtonList.Divider />
      <ButtonList.Item onClick={handle(onDelete)}>Delete form</ButtonList.Item>
    </ButtonList>
  );
}
